
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SE_CORE_MODULE_BUNDLE } from '../core/core.module'

import { SeOverlayService } from './overlay.service'

@NgModule({
  imports: [
	CommonModule
  ],
  providers: [
    SeOverlayService,
  ],
})
export class SeOverlayModule {}

export const SE_OVERLAY_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.overlay`

